import React from "react";
import PropTypes from "prop-types";

import LinkEditor from "editor/components/LinkEditor";
import LinkChange from "editor/components/LinkChange";

export default class Link extends React.Component {
  constructor() {
    super();
    this.state = { linkEl: null };
  }
  render() {
    const { contentState, entityKey } = this.props;
    const { url } = contentState.getEntity(entityKey).getData();

    return (
      <span>
        <a
          href={url}
          target="_blank"
          ref={el => {
            if (!this.state.linkEl) this.setState({ linkEl: el });
          }}
        >
          {this.props.children}
        </a>
        <LinkEditor
          entityKey={entityKey}
          linkEl={this.state.linkEl}
          url={url}
        />
        <LinkChange
          entityKey={entityKey}
          linkEl={this.state.linkEl}
          url={url}
        />
      </span>
    );
  }
}

Link.propTypes = {
  contentState: PropTypes.object.isRequired,
  entityKey: PropTypes.string.isRequired,
};
